// extracted by mini-css-extract-plugin
export default {"feed":"style_feed__D046Q","header":"style_header__nLgLY","itemWrapper":"style_itemWrapper__SIvCt"};